import { CLOUDFRONT_LOGOS_ROOT_URL } from '@shared/config/constants/app';

export const LOGO_VERSION = {
  black: `${CLOUDFRONT_LOGOS_ROOT_URL}/vuz/vuzvip_white.png`,
  white: `${CLOUDFRONT_LOGOS_ROOT_URL}/vuz/vuzvip.png`,
};

export const V3_LOGO_URL = `${CLOUDFRONT_LOGOS_ROOT_URL}/vuz/lp_v3.webp`;

export const LOGO_POSITION = {
  center: 'center',
};

export const WHITE_LOGO = {
  version: LOGO_VERSION.white,
  position: LOGO_POSITION.center,
};

export const BLACK_LOGO = {
  version: LOGO_VERSION.black,
  position: LOGO_POSITION.center,
};

export const V3_LOGO = {
  version: V3_LOGO_URL,
  position: LOGO_POSITION.center,
};
